import React from "react";
import "../CSS/Ironman.css";

export default function Ironman() {
  return (
    <svg width="60%" height="60%" viewBox="-2 -2 236 342" className="Ironman">
      <g fill="none" stroke="#B41414" strokeWidth="2">
        <path
          d="M5.633 182.542c1.169 10.63.688 20.922 3.15 30.764 2.106 8.415 8.433 14.065 11.522 21.742 2.39 5.943 6.473 10.766 9.312 16.257 5.6 10.83 26.42 86.41 26.42 86.41h76.668s28-22.432 40.332-30.053c9.735-6.018 25.236-23.941 25.236-23.941s8.66-37.851 16.222-54.021c3.341-7.144 5.948-17.234 7.97-28.793.022-.126.638-.582.802-.744.415-.41.668-.686 1.14-1.377.595-.872 1.136-1.795 1.536-2.693.267-.598.569-1.326.796-1.783.408-.822.88-2.451 1.084-3.122.43-1.41.672-2.163.827-3.021.034-.186 1.38-5.57 2.234-12.115.38-2.912.652-6.052.803-9.071.067-1.319.116-2.58.201-3.823.16-2.334.095-4.944.087-7.278-.018-5.146-.375-10.128-.853-14.556-1.002-9.264-2.528-15.996-2.528-15.996s.056-5.248.056-7.67c0-9.137-3.935-20.624-4.82-28.546-4.955-44.398-15.885-62.958-44.799-74.558C163.897 8.483 139.336 0 117.798 0c-38.59 0-82 21.016-105.255 54.868C3.904 67.444 4.657 81.602 1.514 97.233c-3.748 18.643 0 39.288 0 60.567 0 8.843 3.19 16.296 4.119 24.742z"
          className="path"
        ></path>
        <path
          fill="#4990E2"
          d="M98.658 176.29s.463 2.097 1.775 3.776c1.293 1.655 3.425 2.89 4.62 3.378 1.766.719 5.258.433 8.946 0 4.95-.582 10.228-1.524 11.914-1.564 7.772-.184 17.702-4.124 17.702-4.124l19.007-9.813-8.125-10.526s-18.991 6.44-28.584 9.374c-7.487 2.289-22.656 6.293-22.656 6.293l-4.599 3.207z"
          className="path"
        ></path>
        <path
          fill="#4990E2"
          d="M11.713 170.695s1.261 10.745 5.728 12.49c8.275 3.233 32.497 2.445 32.497 2.445l1.388-4.976-4.988-3.872-34.625-6.087z"
          className="path"
        ></path>
        <ellipse
          cx="220.31"
          cy="157.2"
          className="path"
          rx="11.69"
          ry="44.4"
        ></ellipse>
        <ellipse
          cx="223.607"
          cy="158.1"
          className="path"
          rx="8.393"
          ry="35.7"
        ></ellipse>
        <path
          d="M205.161 257.07l-1.134-5.348c-.827-3.894-2.634-10.056-4.044-13.782l-13.814-36.5-18.856 41.659-15.783 31.798-2.213 5.24-16.801 16.431-17.001-10.664-59.817.405-3.857 1.627-1.95 5.865-10.41-13.536"
          className="path"
        ></path>
        <path
          d="M194.338 181.231l-8.162 19.972-8.98 12.208-13.384 16.966c-2.46 3.12-5.907 8.525-7.702 12.084l-3.096 6.138c-1.793 3.555-3.48 9.651-3.768 13.614l-.98 13.47-16.137 15.136-11.91-10.532-70.75 1.611-2.607 8.135"
          className="path"
        ></path>
        <path
          d="M50.662 318.415l7.065-7.634 14.514-.583 1.826-4.852 18.777-.583 1.218 5.284h17.206l29.793 9.268 37.032-35.18-15.254 10.795-13.622-14.834"
          className="path"
        ></path>
        <ellipse
          cx="192.734"
          cy="263.1"
          className="path"
          rx="2.698"
          ry="5.1"
          transform="rotate(14 192.734 263.1)"
        ></ellipse>
        <path
          d="M174.026 12.617l-4.538 4.676c-2.77 2.853-6.709 7.91-8.798 11.294l-3.366 5.45 8.667 4.66c3.503 1.883 8.844 5.433 11.942 7.939l6.059 4.902-.145 6.403c-.09 3.976-.64 10.392-1.228 14.318l-2.769 18.498-2.306 16.008a347.96 347.96 0 01-2.409 14.203l-3.373 17.264 9.168 15.713 7.598-42.053c.707-3.918 2.245-10.176 3.429-13.957l1.584-5.063c1.186-3.79 3.39-9.84 4.918-13.505l14.592-34.981"
          className="path"
        ></path>
        <path
          d="M141.282 2.637l-6.491 7.141-7.107 8.413-2.863 4.952 20.655 6.365 12.033 4.574M10.577 58.032l18.856-15.244 7.348-13.613M29.564 42.65l8.297-4.777c3.446-1.983 9.295-4.6 13.084-5.849l6.052-1.996.867-2.566c1.274-3.768 3.983-9.58 6.049-12.979l1.625-2.673"
          className="path"
        ></path>
        <path
          d="M57.051 29.87l-3.027 8.885-1.39 7.808s17.337-6.303 27.653-6.957c10.315-.653 34.24 3.037 34.24 3.037l10.198-19.334"
          className="path"
        ></path>
        <path
          d="M52.712 46.258l-3.383 17.06c-.772 3.898-1.653 10.272-1.968 14.244l-1.955 24.658s15.739 2.712 23.913 2.277c8.175-.435 25.133-4.887 25.133-4.887l7.751-25.21 5.322-15.147c1.318-3.75 3.75-9.716 5.429-13.315l1.463-3.137"
          className="path"
        ></path>
        <path
          d="M60.931 43.662l-6.968 24.307-5.2 21.267-3.249 12.872M194.34 181.376l-.86-3.866-12.54-23.607-11.827 13.883-25.707 14.907c-3.444 1.997-9.463 3.676-13.443 3.75l-24.023.447c-3.981.074-9.823-1.273-9.823-1.273h0l-1.323-8.37-44.426 2.37-2.59 9.224-5.775.764c-3.94.52-10.347.798-14.33.62l-4.933-.222c-3.974-.179-9.568-2.513-12.489-5.209l-4.991-4.606"
          className="path"
        ></path>
        <path
          d="M2.096 164.827l8.472 4.748 16.07 3.157 18.775 2.993 4.872 3.87 44.64-2.355 7.161-5.056 22.654-6.238 20.61-6.854 8.19-2.76 8.337 10.712 7.581.292M194.386 181.15l-2.938 4.267c-2.257 3.276-6.443 8.145-9.335 10.86l-7.127 6.69-12.037 11.684-8.442 9.075c-2.707 2.911-6.774 7.9-9.083 11.142l-14.875 20.887c-2.309 3.243-5.186 8.93-6.43 12.708l-3.884 11.808M18.509 231.394l11.142 17.279 10.013 15.215 6.42 12.663 3.506 5.653M183.953 51.47s3.779-7.542 6.5-10.504c2.78-3.024 4.034-3.428 4.034-3.428 3.297-2.223 8.773-2.43 12.229-.464L210.104 39"
          className="path"
        ></path>
        <path
          d="M97.556 175.607l.514 1.303c1.46 3.7 5.843 6.334 9.797 5.884l22.286-2.536c3.95-.45 10.033-2.267 13.584-4.06l18.046-9.108M10.624 169.768l1.61 6.729c.926 3.872 4.896 7.119 8.877 7.252l27.857.931"
          className="path"
        ></path>
      </g>
    </svg>
  );
}
